// src/components/store/sections/gallery/GalleryV98CinemareelOceanCyan.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV98CinemareelOceanCyan(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={98}
      archKey="cinema_reel"
      archLabel="Cinema Filmstrip Reel"
      palName="OceanCyan"
      grad="from-cyan-500 via-sky-500 to-blue-700"
      lightBg="bg-cyan-50"
      textCol="text-cyan-700"
      borderCol="border-cyan-200"
      btnCls="bg-blue-600 hover:bg-blue-700"
      hexCol="#06b6d4"
      {...props}
    />
  );
}
